<template lang="pug">
    div
        Menu
        Profile
</template>

<script>
import Menu from './components/common/menu/Menu';
import Profile from './components/profile/Profile';

export default {
    name: 'App',
    components: {
        Menu,
        Profile
    }
};
</script>

<style>
    * {
        box-sizing: border-box;
    }

    body {
        margin: 0;
        background-color: #ffffff;
        font-size: 16px;
        font-family: "Raleway", "Helvetica Neue", Helvetica, Arial, sans-serif;
        line-height: 1.4;
    }

    a {
        text-decoration: none;
    }

    h1,
    h4 {
        margin-bottom: 10px;
        font-family: inherit;
        font-weight: 400;
        line-height: 1.3;
        color: inherit;
    }

    h1 {
        font-size: 40px;
        margin-top: 20px;
    }

    h4 {
        font-size: 20px;
        margin-top: 10px;
    }
</style>
